import React, { FC, memo, useMemo } from 'react';
import { Col, Empty, Row, Tabs } from 'udesk-ui';
import { Content, Wrapper } from './components';
import Ellipsis from 'src/components/common/Ellipsis';
import UdeskLocales from 'UdeskLocales';

interface Ticket {
    id: string;
    contents?: {
        key?: string;
        value?: string;
    }[];
}

interface TemplateProps {
    tickets?: Ticket[];
    style?: React.CSSProperties;
    height?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { tickets = [], style, height } = props;

    const contentHeight = useMemo(() => {
        return height && height >= 38 ? height - 38 : undefined;
    }, [height]);

    return (
        <Wrapper style={{ height, ...style }}>
            {tickets.length ? (
                <Tabs size="small">
                    {tickets.map((ticket, index) => (
                        <Tabs.TabPane
                            key={ticket.id}
                            tab={
                                <Ellipsis
                                    style={{ maxWidth: 100 }}
                                    text={`${
                                        /* 关联工单 */ UdeskLocales['current'].components
                                            .associatedTicket.index.associatedWorkOrder
                                    }${index + 1}`}
                                />
                            }
                        >
                            <Content height={contentHeight}>
                                {ticket.contents?.map((content, idx) => (
                                    <Row
                                        key={idx}
                                        style={{ marginBottom: 6 }}
                                        gutter={4}
                                        wrap={false}
                                    >
                                        <Col flex="120px">
                                            <Ellipsis
                                                style={{ width: '100%', textAlign: 'right' }}
                                                text={content.key}
                                                suffix="："
                                            />
                                        </Col>

                                        <Col flex="auto">
                                            <Ellipsis text={content.value} />
                                        </Col>
                                    </Row>
                                ))}
                            </Content>
                        </Tabs.TabPane>
                    ))}
                </Tabs>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </Wrapper>
    );
});

export default Template;
